import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';

import Button from '@/components/Primitive/Button/Button';
import SmartLink from '@/components/Primitive/SmartLink';

interface IGameCard {
  title: string;
  sell: string;
  thumbnail2x: string;
  genre: {
    name: string;
  }[];
  href: string;
  className?: string;
}

const GameCard = ({
  title,
  sell,
  thumbnail2x,
  genre,
  href,
  className,
}: IGameCard) => {
  return (
    <div className={clsx('flex flex-col items-center', className)}>
      <SmartLink
        to={href}
        tabIndex={-1}
        className="group relative -mb-4  block w-[110%] sm:-mb-10"
      >
        <Image
          src={thumbnail2x}
          alt={title}
          width={1000}
          height={400}
          sizes="(max-width: 640px) 100vw, 900px"
          className="object-fit transition-transform group-hover:scale-101 group-focus:scale-101 group-active:scale-[0.99]"
        />
      </SmartLink>
      <div className=" w-full max-w-[850px]  rounded-md bg-gradient-to-t from-blackAlt to-transparent p-7">
        <div className="mx-auto flex w-full max-w-[600px] flex-col items-start space-y-3">
          <div className="space-y-3">
            <h3 className="text-xl font-bold text-cream md:text-2xl">
              {title}
            </h3>
            <p className="line-clamp-3 font-medium text-grayAlt-500 sm:line-clamp-2 md:text-lg">
              {sell}
            </p>
          </div>
          <div className="flex w-full flex-wrap items-start justify-between gap-3 sm:mt-auto sm:flex-row sm:items-center">
            {genre.length > 0 && (
              <div className="text-cream md:text-lg">
                Genre:{' '}
                <span className="block text-grayAlt-500">
                  {genre.map((item) => item.name).join(', ')}
                </span>
              </div>
            )}
            <Button
              to={href}
              color="purple"
              className="uppercase sm:ml-auto sm:min-w-[180px]"
            >
              Play now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameCard;
